import React from 'react';
import { ArrowLeft } from 'lucide-react';
export function TermsPage({
  onBack
}: {
  onBack: () => void;
}) {
  return <div className="min-h-screen bg-cream" data-id="element-498">
      {/* Header */}
      <header className="bg-navy-900 border-b border-navy-800" data-id="element-499">
        <div className="max-w-3xl mx-auto px-4 py-5 flex items-center" data-id="element-500">
          <button onClick={onBack} className="inline-flex items-center gap-2 text-gray-400 hover:text-teal-400 transition-colors text-sm font-medium" data-id="element-501">
            <ArrowLeft className="h-4 w-4" data-id="element-502" />
            Back to home
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 py-16" data-id="element-503">
        <h1 className="text-3xl md:text-4xl font-bold text-navy-800 font-serif mb-3" data-id="element-504">
          Terms of Service
        </h1>
        <p className="text-sm text-text-body mb-10 border-b border-gray-200 pb-6" data-id="element-505">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <div className="space-y-8 text-text-body leading-relaxed" data-id="element-506">
          <section data-id="element-507">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-508">
              1. Product Description
            </h2>
            <p data-id="element-509">
              CPAP Compliance Rescue is a digital educational guide delivered as
              an instant download. It includes a main guide (50–80 pages
              equivalent) and 7 printable worksheets. This product is for
              informational and educational purposes only.
            </p>
          </section>

          <section data-id="element-510">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-511">
              2. Not Medical Advice
            </h2>
            <p data-id="element-512">
              Nothing in this guide constitutes medical advice, diagnosis, or
              treatment. Always consult your physician, sleep specialist, or DME
              provider before making changes to your CPAP therapy. The content
              is designed to help you communicate more effectively with your
              healthcare team.
            </p>
          </section>

          <section data-id="element-513">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-514">
              3. Digital Delivery
            </h2>
            <p data-id="element-515">
              Upon purchase, you will receive immediate access to download the
              digital files. Due to the nature of digital products, all sales
              are final. If you experience technical issues accessing your
              files, contact us and we will resolve the issue promptly.
            </p>
          </section>

          <section data-id="element-516">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-517">
              4. Permitted Use
            </h2>
            <p data-id="element-518">
              Your purchase grants you a personal, non-transferable license to
              use the materials for your own CPAP therapy journey. You may print
              copies of the worksheets for personal use. You may not
              redistribute, resell, or share the digital files.
            </p>
          </section>

          <section data-id="element-519">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-520">
              5. Limitation of Liability
            </h2>
            <p data-id="element-521">
              CPAP Compliance Rescue and its creators are not liable for any
              outcomes related to your CPAP therapy. Individual results vary.
              The guide provides a structured framework, not guaranteed results.
            </p>
          </section>

          <section data-id="element-522">
            <h2 className="text-xl font-bold text-navy-800 font-serif mb-3" data-id="element-523">
              6. Contact
            </h2>
            <p data-id="element-524">
              For questions about these terms, please reach out via the contact
              information provided with your purchase confirmation.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-525">
          <button onClick={onBack} className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 transition-colors font-medium" data-id="element-526">
            <ArrowLeft className="h-4 w-4" data-id="element-527" />
            Back to home
          </button>
        </div>
      </main>
    </div>;
}